import { z } from "zod";
import { APIClient } from "./api_helper";

export const api = new APIClient();

// Cost Attribution schemas
export const CostAttributionResponseSchema = z.object({
  enabled: z.boolean(),
  mode: z.string(),
});

export const UpsertCostAttributionRequestSchema = z.object({
  enabled: z.boolean(),
  mode: z.string(),
});

export type CostAttributionResponse = z.infer<typeof CostAttributionResponseSchema>;
export type UpsertCostAttributionRequest = z.infer<typeof UpsertCostAttributionRequestSchema>;

// Cost Attribution API functions
export const getCostAttributionConfig = () => {
  return api
    .get<CostAttributionResponse>(
      "/global_config/",
      { config_type: "cost_attribution" },
      0,
      CostAttributionResponseSchema
    )
    .then(config => config || { enabled: false, mode: "warehouse" })
    .catch(() => ({ enabled: false, mode: "warehouse" }));
};

export const upsertCostAttributionConfig = (data: UpsertCostAttributionRequest) =>
  api.post<CostAttributionResponse>(
    "/global_config/cost-attribution",
    data,
    CostAttributionResponseSchema
  );
